import type { ButtonProps } from '@sravni/react-design-system/lib/Button';
import { v7 as uuidv7 } from 'uuid';

import type { MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';

import { sendEventPreApprovedOfferClick, sendEventPreApprovedOfferRedirect } from 'shared/lib/sendGAEvents';

import { useSendOffer } from 'features/OfferControls';
import { OfferControlsTexts } from 'features/OfferControls/OfferControls.texts';

import { OfferButton } from '../OfferButton/OfferButton';

interface IGoToRefOfferProps {
  offer: MPLPreApprovalOffer;
  buttonProps?: ButtonProps;
}

export const GoToRefMplPreApprovalOffer: FC<IGoToRefOfferProps> = (props) => {
  const { offer, buttonProps } = props;
  const { onClick: onClickProp, ...otherButtonProps } = buttonProps || {};
  const { sendMplPreApprovalOffer } = useSendOffer('Ref');
  const referralLink = offer.buttonLink || '';
  const { productName } = offer;

  const onClick = () => {
    const uuid = uuidv7();
    if (!offer.apiStatus) {
      sendEventPreApprovedOfferClick({
        bankName: offer.organizationName,
        offerName: productName,
      });

      sendEventPreApprovedOfferRedirect({
        bankName: offer.organizationName,
        offerName: productName,
        redirectUrl: referralLink || '',
      });

      sendMplPreApprovalOffer(offer, { referralUrl: referralLink, uuid });
    }

    if (!referralLink) {
      return;
    }

    window.open(referralLink, '_blank');
  };

  return (
    <OfferButton
      {...otherButtonProps}
      variant="primary"
      color="dark"
      onClick={(event) => {
        event.stopPropagation();
        onClick();
        onClickProp?.(event);
      }}
    >
      {OfferControlsTexts.sendMplOfferLabel}
    </OfferButton>
  );
};
